<template>
    <div class="question-form-wrapper scroll-tracker">
        <div class="question-info">
            <div class="form-label required">
                {{ classLabel }}
                <em class="gray-label" v-if="!!sceneClassId">({{ sceneClassId }})</em>
            </div>
            <Select
                class="class-selector"
                @selectClick="selectClick"
                :disabled="disabledSceneId"
                :initValue="initSceneId"
                :topOrBottom="86"
                :options="sceneClass"
                @menuClick="sceneSelected"
            >
                <Search :placeholder="palceHolder" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
            </Select>
            <div class="form-label required">
                {{ standQuesLabel }}
                <em class="gray-label" v-if="!!curQuestionId">({{ curQuestionId }})</em>
            </div>
            <input
                :placeholder="standPlaceHolder"
                v-model="standQuestion"
                type="text"
                class="form-input"
                :class="{ 'rtl': isStandQuesArabic  }"
                @input="inputChange()"
                @blur="autoFillTip"
            />
            <div class="form-label required">
                <!-- 前端是否显示踩赞 -->
                {{ isLikeDisplayLabel }}
            </div>
            <el-radio-group v-model="isLikeDisplay">
                <el-radio
                    v-for="item in likeDisplayOptions"
                    :label="item.value"
                >
                    {{ item.text }}
                </el-radio>
            </el-radio-group>
            <div class="form-label required">
                {{ optionTipLabel }}
            </div>
            <input :class="{ 'rtl': isOpTipArabic  }" :placeholder="optionPlaceHolder" v-model="optionTip" type="text" class="form-input" @input="inputChange" />
        </div>
        <div class="similar-edit form-label">
            <div class="similar-edit-lablel">
                <div class="similar-edit-text" :title="similarLabel">{{ similarLabel }}</div>
                <em class="gray-label">({{ similarCount }})</em>
            </div>
            <RoundButton class="similar-edit-btn" :class="{ on: curPanel == 'SimilarPanel' }" :text="similarBtnLabel" @btnClick="similarClick" />
        </div>

        <div class="form-label answer-label">
            {{ answerLabel }}
        </div>
        <div class="answer-list scroll-tracker">
            <div class="answer-item" v-for="(answer, idx) in answerList" :key="idx" v-show="answer.updateState != 'delete'">
                <RoundButton
                    class="answer-item-btn"
                    :class="{ on: answer == currentAnswer }"
                    :text="answer.name"
                    @btnClick="switchAnswer(answer, idx)"
                />
                <span class="op">
                    <i
                        class="transfer"
                        @mousedown="transPosition($event, answer)"
                    />
                </span>
                <i class="answer-item-delete" @click="deleteAnswer(answer)"></i>
                <div class="answer-item-status" :class="{using: answer.props.answerStatus === '1',outOfUse: answer.props.answerStatus === '0'}"></div>
                <div class="answer-popUp-container-status">
                    <div class="answer-item-popUp">
                      <span class="answer-item-text">{{ answer.props.answerStatus === '1' ? answerEnabled : answerDeactivated }}</span>
                    </div>
                  </div>
            </div>
            <div class="answer-item answer-add">
                <RoundButton class="answer-item-btn" :icon="addIcon" @btnClick="addAnswer" />
            </div>
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import i18n from "@/i18n";
import { isArabicText } from "@/views/zhiji/js/common/util.js";

export default {
    name: "LeftQuestionForm",
    components: {
        Select,
        RoundButton,
        Search
    },
    props: ["curPanel", "default"],
    data() {
        return {
            standQuestion: "",
            optionTip: "",
            currentAnswerUid: "",
            lockingStatus: 0,
            isStandQuesArabic: false,
            isOpTipArabic: false
        };
    },
    watch: {
        questionInfo() {
            this.initInputs();
        }
    },
    computed: {
        answerEnabled() {
            return this.$t("zhiji.knowlege.quesEditModal.enabled");
        },
        answerDeactivated() {
            return this.$t("zhiji.knowlege.quesEditModal.deactivated");
        },
        classLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.categoriy");
        },
        standQuesLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.standQues");
        },
        standPlaceHolder() {
            return this.$t("zhiji.knowlege.quesEditModal.inputStand");
        },
        optionTipLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.shortbarTip");
        },
        optionPlaceHolder() {
            return this.$t("zhiji.knowlege.quesEditModal.enterShortBarTip");
        },
        similarLabel() {
            return this.$t("zhiji.knowlege.quesEditModal.simliarQues");
        },
        palceHolder() {
            return this.$t("zhiji.knowlege.sceneSearch");
        },
        answerLabel() {
            return this.$t("zhiji.common.answer");
        },
        similarBtnLabel() {
            return this.$t("zhiji.common.edit");
        },
        sceneClass() {
            let scenes = this.getStorePorp("sceneClassDatas").slice(0) || [];

            // 添加默认状态
            scenes.unshift({
                label: this.$t("zhiji.knowlege.quesEditModal.selectScene"),
                value: "def"
            });

            return scenes;
        },
        initSceneId() {
            const questionInfo = this.questionInfo;
            return "" + questionInfo.sceneClassId;
        },
        curQuestionId() {
            const questionInfo = this.questionInfo;
            return questionInfo.questionId;
        },
        sceneClassId() {
            const questionInfo = this.questionInfo;
            return questionInfo.sceneClassId;
        },
        questionInfo() {
            return this.getStorePorp("questionInfo");
        },
        addIcon() {
            return "url(" + this.zhiji.staticPath() + "class-spr.png) -296px 1px";
        },
        answerList() {
            return this.getStorePorp("answers") || [];
        },
        similarCount() {
            return this.getStorePorp("totalSimilar");
        },
        currentAnswer() {
            return this.getStorePorp("currentAnswer");
        },
        disabledSceneId() {
            return !this.isDefaultLang(this.getStorePorp("currentSynonym")) || this.lockingStatus === 1;
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        },
        isLikeDisplayLabel() {
            return this.$t("zhiji.knowlege.treeModal.isLikeDisplay");
        },
        likeDisplayOptions() {
            return [
                { value: 1, text: this.$t('zhiji.common.yes') },
                { value: 0, text: this.$t('zhiji.common.no') },
            ]
        },
        isLikeDisplay: {
            get () {
                return this.getStorePorp('questionInfo').isLikeDisplay;
            },
            set (value) {
                this.$store.commit('zhiji/updateEditQsForm', {
                    isLikeDisplay: value,
                });
            },
        },
    },
    mounted() {
        this.initInputs();
    },
    methods: {
        initInputs() {
            let qInfo = this.questionInfo;
            this.standQuestion = this.default || qInfo.standQuestion;
            this.optionTip = this.default || qInfo.optionTip;
            this.lockingStatus = qInfo.lockingStatus;
            this.inputChange(true);
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        sceneSelected(sceneClass) {
            this.$store.commit("zhiji/updateEditQsForm", {
                sceneClassId: sceneClass.value
            });
        },
        similarClick() {
            this.$emit("similarEdit");
        },
        switchAnswer(answer, answerIdx) {
            if (this.$store.state.zhiji.questionEdit.similarIsEdit) {
                // 相似问的文本域有值 提示下
                this.$confirm(i18n.t("zhiji.knowlege.quesEditModal.hasEditSimilarWarnTip"), this.$t("zhiji.common.tips"), {
                    confirmButtonText: this.$t("zhiji.common.confirm"),
                    cancelButtonText: this.$t("zhiji.common.cancel"),
                    type: "warning",
                });
                return;
            }
            // 只有第一个答案没有配置浮动框的时候，需要推荐浮动框
            if (answerIdx == 0 && !answer.options.length) {
                this.currentAnswerUid = answer.uId;
                answer.options.push(...this.getStorePorp("recommendOptions"));
            }
            this.$emit("switchAnswer");
            this.$store.commit("zhiji/editQsSelectAnswer", answer);
        },
        transPosition (event, answer) {
            this.zhiji.dragStart(event, 'answer-item', 'v', (newIdx) => {
                this.$store.commit('zhiji/editQsTanferAnswer', {
                    uId: answer.uId,
                    newIdx,
                });
            });
        },
        async addAnswer() {
            this.$store.dispatch("zhiji/editQsAddAnswerWidthFirstOption");
        },
        selectClick() {
            this.$store.commit("zhiji/searchScenes", {
                field: ""
            });
        },
        inputChange(noChange) {
            this.isStandQuesArabic = isArabicText(this.standQuestion);
            this.isOpTipArabic = isArabicText(this.optionTip);
            this.$nextTick(() => {
                this.$store.commit("zhiji/updateEditQsForm", {
                    standQuestion: this.standQuestion,
                    optionTip: this.optionTip || this.standQuestion,
                    noChange
                });
            });
        },
        autoFillTip() {
            !this.optionTip && (this.optionTip = this.standQuestion);
        },
        searchReferenceSimilars() {
            this.$store.dispatch("zhiji/searchReferenceSimilars", {
                keywords: this.standQuestion
            });
        },
        deleteAnswer(answer) {
            this.$store.commit("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.quesEditModal.delAnswerTip"),
                    confirm: () => {
                        this.$store.commit("zhiji/editQsDeleteAnswer", {
                            uId: answer.uId
                        });
                    }
                }
            });
        },
        searchChange(data) {
            this.$store.commit("zhiji/searchScenes", {
                field: data.value
            });
        },
        isDefaultLang(lang) {
            return this.defaultLang == lang;
        }
    }
};
</script>

<style lang="less" scoped>
.question-form-wrapper {
    position: relative;
    width: 272px;
    padding: 0 18px 16px;
    font-size: 14px;
    border-right: 1px solid #d8e4f0;
    background: #f2f7fb;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .form-label {
        margin: 20px 0 5px 0;
        font-weight: bold;

        .gray-label {
            color: #9b9ba3;
        }
        &:first-child {
            margin-top: 10px;
        }
    }

    .required {
        &:before {
            color: #fe0931;
            content: "*";
            display: inline-block;
        }
    }

    .form-input {
        border-radius: 4px;
        padding: 7px 8px;
        background: #fff;
        width: 100%;
        border: solid 1px #d8e4f0;
        box-sizing: border-box;
        color: #41475e;

        &:focus {
            border-color: #2088f3;
        }
    }

    .question-info {
        .class-selector {
            width: 235px;
            color: #9b9ba3;
        }

        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
        }
    }

    .similar-edit {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .similar-edit-lablel {
        display: flex;
        overflow: hidden;
    }

    .similar-edit-text {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
    }

    .similar-edit-btn {
        flex-grow: 0;
        flex-shrink: 0;
    }

    .similar-edit-btn,
    .answer-item-btn {
        position: relative;
        border: solid 1px #d8e4f0 !important;
        color: #41475e !important;
        background: #fff !important;
        box-shadow: none !important;
        box-sizing: border-box;
        line-height: 30px;
        width: 60px;
        min-width: 0;
        margin-right: 0px;

        &:hover,
        &.on {
            border-color: #9ba5cc !important;
            box-shadow: 2px 0 6px rgba(46, 98, 151, 0.2) !important;
            &:after {
                position: absolute;
                top: -2px;
                left: -2px;
                content: "";
                width: 100%;
                height: 100%;
                border: 2px solid #9ba5cc;
                border-radius: 20px;
            }
        }
    }

    .answer-list {
        padding: 5px 2px;
        position: relative;
    }

    .answer-label {
        padding-top: 10px;
        border-top: 1px solid #d8e4f0;
    }

    .answer-item {
        margin-bottom: 8px;
        position: relative;

        &:hover {
            .answer-item-delete {
                display: inline-block;
            }
        }
        .op {
            margin-bottom: 8px;
            cursor: pointer;
            display: inline-flex;
            width: 26px;
            height: 26px;
            border-radius: 50%;
            align-items: center;
            justify-content: center;
            box-shadow: 0px 2px 6px rgba(46, 98, 151, 0.2);
            background: #fff;
            position: absolute;
            top: 6px;
            right: -20px;
            .transfer {
                position: relative;
                display: inline-block;
                width: 13px;
                height: 18px;
                vertical-align: middle;
                background: url("@{zhijiStaticImagePath}class-spr.png");
                background-position: -113px 0;
                    &:hover {
                        background-position: -113px -22px;
                    }
            }
        }
    }

    .answer-item-delete {
        position: absolute;
        right: 0;
        top: -3px;
        width: 18px;
        height: 18px;
        background: url("@{zhijiStaticImagePath}class-spr.png") -4px -1px;
        display: none;

        &:hover {
            background-position: -252px -20px;
        }
    }

    .answer-item-btn {
        position: relative;
        font-size: 12px;
        box-sizing: border-box;
        line-height: 41px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 210px;
        height: 41px;
        padding: 0 26px 0 34px;
        text-align: center;
    }
    .answer-item-status {
        position:absolute;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        top: 14.5px;
        left: 15px;
    }
    .using {
        background-color: #3dbeff;
    }
    .outOfUse {
        background-color: #dae5ef;
    }
    .answer-popUp-container-status {
        display: none;
        .answer-item-popUp {
            z-index: 100;
            position: absolute;
            width: 41px;
            height: 17px;
            color:#f0f8ff;
            background-color: #333333;
            border-radius: 3px;
            top: -8px;
            left: 0px;
            .answer-item-text {
                display: inline-block;
                position: absolute;
                top: 1px;
                left: 2px;
                font-size: 12px;
                text-align: center;
                transform: scale(0.8);
                line-height: 15px;
            }
        }
    }
    .answer-item-status:hover+.answer-popUp-container-status {
        display: block;
    }
    .rtl {
        direction: rtl;
    }
}
</style>
